var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":_vm.title,"value":_vm.value,"width":"50%"},on:{"on-visible-change":_vm.visibleChange}},[_c('Table',{attrs:{"columns":_vm.copyColumn,"data":_vm.data.cobyData}}),_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{on:{"click":_vm.cancel}},[_vm._v("关闭")])],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f0e256","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/follow/followUpAppointment/copyDataDetailed.vue
// module id = null
// module chunks = 